import type { DeviceKind, MailPilotDesktopBridge } from '@mailpilot/shared';

export function bridge(): MailPilotDesktopBridge | null {
  return typeof window !== 'undefined' && window.mailpilotDesktop ? window.mailpilotDesktop : null;
}

export const isDesktop = (): boolean => bridge() !== null;

function browserName(): string {
  const ua = navigator.userAgent;
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\//.test(ua)) return 'Opera';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Browser';
}

function platformName(): string {
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  const p = nav.userAgentData?.platform || navigator.platform || '';
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return 'iOS';
  if (/Android/i.test(navigator.userAgent)) return 'Android';
  if (/Mac/i.test(p)) return 'macOS';
  if (/Win/i.test(p)) return 'Windows';
  if (/Linux/i.test(p)) return 'Linux';
  return p || 'Unknown';
}

let cachedName: string | null = null;
export async function deviceName(): Promise<string> {
  if (cachedName) return cachedName;
  const b = bridge();
  if (b) {
    try {
      cachedName = await b.deviceName();
      return cachedName;
    } catch {
      /* fall through */
    }
  }
  cachedName = `${browserName()} on ${platformName()}`;
  return cachedName;
}

export function deviceKind(): DeviceKind {
  if (isDesktop()) return 'desktop';
  const narrow = window.matchMedia('(max-width: 767px)').matches;
  const touch = window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
  return narrow && touch ? 'mobile-web' : 'web';
}
